export default __webpack_public_path__ + "static/media/subscribe-week.34800753.png";